export default "__VITE_ASSET__sIA4xkIC__";